import { _mock } from "src/_mock";
import dayjs from "dayjs";
import { IAnvändare } from "@/src/types/nya/common";

// To get the user from the <AuthContext/>, you can use

// Change:
// import { useMockedUser } from 'src/auth/hooks';
// const { user } = useMockedUser();

// To:
// import { useAuthContext } from 'src/auth/hooks';
// const { user } = useAuthContext();

// ----------------------------------------------------------------------

export const ROTTNEVÄGEN43 = {
  gata: "Rottnevägen",
  nr: "43",
  våning: "",
  postNummer: "128 48",
  ort: "Bagarmossen",
  fullständigAdress: "Rottnevägen 43, 128 48 Bagarmossen",
};

export function useMockadAnvandare(): IAnvändare {
  const anvandare = {
    id: '111313',
    namn: {
      förnamn: "Sasha",
      efternamn: "Bolund",
      fullständigtNamn: "Sasha Bolund",
    },
    emailAdress: "bolundsasha@gmail.com",
    personNummer: "19900101-1234",
    telefonNummer: "0739-816856",
    harGenomgåttOnboarding: true,
    roller: [
      {
        aktiv: true,
        namn: "organisation_admin",
        skapadesPå: dayjs("2023-10-11"),
      },
      {
        aktiv: true,
        namn: "brf_styrelseledamot",
        skapadesPå: dayjs("2025-10-11"),
      },
      {
        aktiv: true,
        namn: "egenföretagare",
        skapadesPå: dayjs('2025-01-01'),
      },
    ],
    adress: ROTTNEVÄGEN43,
    koppladeOrganisationer: [{
      id: "2242",
      organisationsNamn: "Bolund Ink",
      organisationsNummer: "5253345-5812",
      räkenskapsår: [],
      momsregisteringsnummer: "SE52533455812",
      organisationsTyp: "Aktiebolag",
      adress: ROTTNEVÄGEN43,
    }],
    avatarUrl: "https://brf-app-bilder.s3.eu-north-1.amazonaws.com/sasha.jpg",
    valtSpråk: "sv",
    // photoURL: _mock.image.avatar(24),
    // country: _mock.countryNames(1),
    address: ROTTNEVÄGEN43.fullständigAdress,
    // state: "Stockholm",
    // city: "Bagarmossen",
    // zipCode: "128 48",
    // allowedRoles: ["brf_styrelseledamot", "brf_admin"],
    // om: "---SASHA--",
    // role: "admin",
    // isPublic: true,
  };

  return anvandare;
}
